import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

import StayRestrictionsAccordion, {
  type StayRestrictionsAccordionState,
} from './stay-restrictions-accordion';

interface StayRestrictionsPanelSignature {
  Args: {
    hotelState: StayRestrictionsAccordionState;
  };
}

const StayRestrictionsPanel = <template>
  <StayRestrictionsAccordion
    @id="hotel-min-los"
    @state={{@hotelState}}
    @title={{t "general.hotel"}}
  />
</template> satisfies TOC<StayRestrictionsPanelSignature>;

export default StayRestrictionsPanel;
